var provider = {
	letters: 'йцукенгшщзхїфівапролджєячсмитьбю',

	words_list: ['Але', 'щоб', 'ви', 'зрозуміли', 'звідки', 'виникає', 'це', 'хибне',
	'уявлення', 'людей', 'цуратись', 'насолоди', 'і', 'вихваляти', 'страждання', 'я',
	'розкрию', 'перед', 'вами', 'всю', 'картину', 'роз’ясню', 'що', 'саме', 'говорив',
	'цей', 'чоловік', 'який', 'відкрив', 'істину', 'якого', 'б', 'назвав', 'зодчим',
	'щасливого', 'життя', 'дійсно', 'ніхто', 'не', 'відкидає', 'зневажає', 'уникає',
	'насолод', 'тільки', 'через', 'те', 'це', 'насолоди', 'лише', 'через', 'тих',
	'вміє', 'розумно', 'вдаватися', 'насолоді', 'осягають', 'великі', 'страждання',
	'так', 'само', 'немає', 'нікого', 'полюбивши', 'вважав', 'за', 'краще', 'зажадав',
	'би', 'саме', 'страждання', 'тільки', 'інший', 'раз', 'виникають', 'такі', 'обставини',
	'коли', 'біль', 'приносять', 'якесь', 'чималу', 'насолоду', 'якщо', 'скористатися',
	'найпростішим', 'прикладом', 'хто', 'нас', 'став', 'би', 'займатися', 'якими', 'було',
	'тяжкими', 'фізичними', 'вправами', 'приносило', 'з', 'собою', 'якоїсь', 'користі',
	'міг', 'би', 'по', 'справедливості', 'дорікнути', 'прагнення', 'до', 'насолоди',
	'яке', 'не', 'несло']
};

module.exports = provider;
